module.exports = __webpack_public_path__ + "img/Notes.18b9fc92.png";